import { setStorageItem, STORAGE_ACTION } from '@utils/storage';
import { createReducer } from 'typesafe-actions';
import {
  CREATE_TEMP_CLIENT,
  GET_CLIENT,
  INIT_CLIENT,
  UPDATE_CLIENT,
  GET_CLIENT_TOKEN,
  UPDATE_REDIRECT_PATH,
  UPDATE_TOKEN,
  LOGOUT
} from './actions';
import { IClientState, Action } from './types';

export const initialState: IClientState = {};

export const client = createReducer<IClientState, Action>(initialState, {
  [INIT_CLIENT]: () => {
    return initialState;
  },
  [CREATE_TEMP_CLIENT]: (state, action) => {
    return {
      ...state,
      ...action.payload
    };
  },
  [GET_CLIENT]: (state, action) => {
    return {
      ...state,
      ...action.payload
    };
    // return initialState;
  },
  [UPDATE_CLIENT]: (state, action) => {
    return {
      ...state,
      ...action.payload
    };
  },
  [GET_CLIENT_TOKEN]: (state, action) => {
    return {
      ...state,
      ...action.payload
    };
  },
  [UPDATE_REDIRECT_PATH]: (state, action) => {
    setStorageItem(STORAGE_ACTION.REDIRECT_PATH, action.payload);
    return {
      ...state
    };
  },
  [UPDATE_TOKEN]: (state, action) => {
    if (action.payload.accessToken && action.payload.refreshToken) {
      const hasKeepLoggedInToken = localStorage.getItem(
        STORAGE_ACTION.KEEP_LOGGED_IN
      );

      const { isKeepLoggedIn } = action.payload;

      if (hasKeepLoggedInToken || isKeepLoggedIn) {
        setStorageItem(
          STORAGE_ACTION.KEEP_LOGGED_IN,
          action.payload.refreshToken
        );
      }

      localStorage.setItem(
        STORAGE_ACTION.CLIENT_ACCESS_TOKEN,
        action.payload.accessToken as string
      );
      localStorage.setItem(
        STORAGE_ACTION.CLIENT_REFRESH_TOKEN,
        action.payload.refreshToken as string
      );
    }

    return {
      ...state,
      ...action.payload,
      isKeepLoggedIn: undefined
    };
  },
  [LOGOUT]: () => ({})
});
